import React from "react";

/**
 * Linchpin button. Variants: primary | secondary | ghost | danger. Sizes: sm | md | lg.
 */
const LpButton = React.forwardRef(function LpButton(
  { variant = "primary", size = "md", block = false, icon = null, className = "", children, type = "button", ...rest },
  ref
) {
  const cls = [
    "lp-btn",
    `lp-btn--${variant}`,
    `lp-btn--${size}`,
    block ? "lp-btn--block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button ref={ref} type={type} className={cls} {...rest}>
      {icon}
      {children}
    </button>
  );
});

export default React.memo(LpButton);
